import { useCartContext } from "app/providers/CartProvider";
import { toast } from "react-toastify";
import Icon, { IconTypes } from "shared/ui/icon";
import { Delete } from "shared/ui/icons/Delete";
import Text from "shared/ui/typography/Text";

interface Props {
  index: number;
}

const StandardProductControls = ({ index }: Props) => {
  const { removeCartStandardProduct, cart } = useCartContext();

  const onRemoveClick = () => {
    toast.success("Product verwijderd");
    removeCartStandardProduct(index);
  };

  // Get the product that needs to be edited
  const editableProduct = cart.standardProducts[index];

  // Redirect to the product page with the product id
  const onEditClick = () => {
    window.location.href =
      "/producten/zen-en-zacht-taupe-zwart?standard-product=" +
      editableProduct.id +
      "&stdProductIndex=" +
      index;
  };
  return (
    <div
      className={`gg-mt-5 gg-flex gg-justify-center gg-gap-x-5 gg-border-t gg-py-3.5 gg-text-xs md:gg-text-sm lg:gg-mt-0 lg:gg-flex-col lg:gg-justify-between lg:gg-gap-y-5 lg:gg-border-0 lg:gg-py-0`}
    >
      <button
        className="gg-group gg-flex gg-items-center"
        onClick={onEditClick}
      >
        <Icon
          name={IconTypes.EDIT}
          className="gg-mr-2.5 group-hover:gg-opacity-80"
        />
        <Text className="gg-text-left gg-underline group-hover:gg-opacity-80">
          Wijzig artikel
        </Text>
      </button>

      <button
        className="gg-group gg-flex gg-items-center"
        onClick={() => onRemoveClick()}
      >
        <Delete className="gg-mr-2.5 gg-fill-red group-hover:gg-fill-red-700" />
        <Text className="gg-text-left gg-text-red gg-underline group-hover:gg-text-red-700">
          Verwijderen
        </Text>
      </button>
    </div>
  );
};
export default StandardProductControls;
